"use strict";

theme.parallaxSections = {};

theme.Parallax = (function () {
  var speed = 0.85;
  var reset = false;

  function parallax(container, args) {
    this.isInit = false;
    this.isVisible = false;
    this.container = container;
    this.image = container.querySelector(".parallax-image");
    this.namespace = args.namespace;
    this.desktopOnly = args.desktopOnly;

    if (!this.container || !this.image) {
      return;
    }

    // If set for desktop only, setup listeners for disabling
    // on mobile and re-enabling on desktop
    if (this.desktopOnly) {
      document.addEventListener(
        "matchSmall",
        function () {
          this.destroy();
        }.bind(this),
      );

      document.addEventListener(
        "unmatchSmall",
        function () {
          this.init(true);
        }.bind(this),
      );
    }

    this.init(this.desktopOnly);
  }

  parallax.prototype = Object.assign({}, parallax.prototype, {
    init: function (desktopOnly) {
      // Reset in case initialized again
      if (this.isInit) {
        this.destroy();
      }

      this.isInit = true;

      // Do not setup scroll event if on mobile
      if (desktopOnly && theme.config.bpSmall) {
        return;
      }

      // Set position on page load
      this.setSizes();
      this.scrollHandler();

      var observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              window.on("scroll" + this.namespace, this.onScroll.bind(this));
            } else {
              window.off("scroll" + this.namespace);
            }
          });
        },
        { rootMargin: "200px 0px 200px 0px" },
      );

      observer.observe(this.container);

      window.on(
        "resize" + this.namespace,
        theme.utils.debounce(250, this.setSizes.bind(this)),
      );

      document.addEventListener(
        "shopify:section:reorder",
        theme.utils.debounce(250, this.onReorder.bind(this)),
      );
    },

    onScroll: function () {
      if (!this.isVisible) {
        return;
      }

      // If a scroll event finds Shopify's review app,
      // update parallax scroll positions because of page reflows
      if (window.SPR && !reset) {
        this.setSizes();
        reset = true;
      }

      requestAnimationFrame(this.scrollHandler.bind(this));
    },

    scrollHandler: function () {
      var shiftDistance = (window.scrollY - this.elTop) * speed;
      this.image.style.transform =
        "translate3d(0, " + shiftDistance + "px, 0)";
    },

    setSizes: function () {
      var rect = this.container.getBoundingClientRect();
      this.elTop = rect.top + window.scrollY;
    },

    onReorder: function () {
      this.setSizes();
      this.onScroll();
    },

    destroy: function () {
      this.image.style.transform = "none";
      window.off("scroll" + this.namespace);
      window.off("resize" + this.namespace);
    },
  });

  return parallax;
})();

if (typeof window.noUiSlider === "undefined") {
  throw new Error(
    "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js",
  );
}

theme.Slideshow = (function () {
  var classes = {
    animateOut: "animate-out",
    isPaused: "is-paused",
    isActive: "is-active",
  };

  var selectors = {
    allSlides: ".slideshow__slide",
    currentSlide: ".is-selected",
    wrapper: ".slideshow-wrapper",
    pauseButton: ".slideshow__pause",
  };

  var productSelectors = {
    thumb: ".product__thumb-item:not(.hide)",
    links: ".product__thumb-item:not(.hide) a",
    arrow: ".product__thumb-arrow",
  };

  var defaults = {
    adaptiveHeight: false,
    autoPlay: false,
    avoidReflow: false,
    childNav: null,
    childNavScroller: null,
    childVertical: false,
    dragThreshold: 7,
    fade: false,
    friction: 0.8,
    initialIndex: 0,
    pageDots: false,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    rightToLeft: theme.config.rtl,
    selectedAttraction: 0.14,
    setGallerySize: true,
    wrapAround: true,
  };

  function slideshow(el, args) {
    this.el = el;
    this.args = Object.assign({}, defaults, args);

    // Setup listeners as part of arguments
    this.args.on = {
      ready: this.init.bind(this),
      change: this.slideChange.bind(this),
      settle: this.afterChange.bind(this),
    };

    if (this.args.childNav) {
      this.childNavEls = this.args.childNav.querySelectorAll(
        productSelectors.thumb,
      );
      this.childNavLinks = this.args.childNav.querySelectorAll(
        productSelectors.links,
      );
      this.arrows = this.args.childNav.querySelectorAll(
        productSelectors.arrow,
      );
      if (this.childNavLinks.length) {
        this.initChildNav();
      }
    }

    if (this.args.avoidReflow) {
      avoidReflow(el);
    }

    this.slideshow = new Flickity(el, this.args);

    if (this.args.autoPlay) {
      var wrapper = el.closest(selectors.wrapper);
      this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
      if (this.pauseBtn) {
        this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
      }
    }

    // Reset dimensions on resize
    window.on(
      "resize",
      theme.utils.debounce(
        300,
        function () {
          this.resize();
        }.bind(this),
      ),
    );

    // Set flickity-viewport height to first element to
    // avoid awkward page reflows while initializing.
    // Must be added in a `style` tag because element does not exist yet.
    // Slideshow element must have an ID
    function avoidReflow(el) {
      if (!el.id) return;
      var firstChild = el.firstChild;
      while (firstChild != null && firstChild.nodeType == 3) {
        // skip TextNodes
        firstChild = firstChild.nextSibling;
      }
      var style = document.createElement("style");
      style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
      document.head.appendChild(style);
    }
  }

  slideshow.prototype = Object.assign({}, slideshow.prototype, {
    init: function (el) {
      this.currentSlide = this.el.querySelector(selectors.currentSlide);

      // Optional onInit callback
      if (this.args.callbacks && this.args.callbacks.onInit) {
        if (typeof this.args.callbacks.onInit === "function") {
          this.args.callbacks.onInit(this.currentSlide);
        }
      }

      if (window.AOS) {
        AOS.refresh();
      }
    },

    slideChange: function (index) {
      // Outgoing fade styles
      if (this.args.fade && this.currentSlide) {
        this.currentSlide.classList.add(classes.animateOut);
        this.currentSlide.addEventListener(
          "transitionend",
          function () {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this),
        );
      }

      // Match index with child nav
      if (this.args.childNav) {
        this.childNavGoTo(index);
      }

      // Optional onChange callback
      if (this.args.callbacks && this.args.callbacks.onChange) {
        if (typeof this.args.callbacks.onChange === "function") {
          this.args.callbacks.onChange(index);
        }
      }

      // Show/hide arrows depending on selected index
      if (this.arrows && this.arrows.length) {
        this.arrows[0].classList.toggle("hide", index === 0);
        this.arrows[1].classList.toggle(
          "hide",
          index === this.childNavLinks.length - 1,
        );
      }
    },
    afterChange: function (index) {
      // Remove all fade animation classes after slide is done
      if (this.args.fade) {
        this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
          slide.classList.remove(classes.animateOut);
        });
      }

      this.currentSlide = this.el.querySelector(selectors.currentSlide);

      // Match index with child nav (in case slider height changed first)
      if (this.args.childNav) {
        this.childNavGoTo(this.slideshow.selectedIndex);
      }
    },
    destroy: function () {
      if (this.args.childNav && this.childNavLinks.length) {
        this.childNavLinks.forEach((a) => {
          a.classList.remove(classes.isActive);
        });
      }
      this.slideshow.destroy();
    },
    reposition: function () {
      this.slideshow.reposition();
    },
    _togglePause: function () {
      if (this.pauseBtn.classList.contains(classes.isPaused)) {
        this.pauseBtn.classList.remove(classes.isPaused);
        this.slideshow.playPlayer();
      } else {
        this.pauseBtn.classList.add(classes.isPaused);
        this.slideshow.pausePlayer();
      }
    },
    resize: function () {
      this.slideshow.resize();
    },
    play: function () {
      this.slideshow.playPlayer();
    },
    pause: function () {
      this.slideshow.pausePlayer();
    },
    goToSlide: function (i) {
      this.slideshow.select(i);
    },
    setDraggable: function (enable) {
      this.slideshow.options.draggable = enable;
      this.slideshow.updateDraggable();
    },

    initChildNav: function () {
      this.childNavLinks[this.args.initialIndex].classList.add("is-active");

      // Setup events
      this.childNavLinks.forEach((link, i) => {
        // update data-index because image-set feature may be enabled
        link.setAttribute("data-index", i);

        link.addEventListener(
          "click",
          function (evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget));
          }.bind(this),
        );
        link.addEventListener(
          "focus",
          function (evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget));
          }.bind(this),
        );
        link.addEventListener(
          "keydown",
          function (evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }
          }.bind(this),
        );
      });

      // Setup optional arrows
      if (this.arrows.length) {
        this.arrows.forEach((arrow) => {
          arrow.addEventListener("click", this.arrowClick.bind(this));
        });
      }
    },

    getChildIndex: function (target) {
      return parseInt(target.dataset.index);
    },

    childNavGoTo: function (index) {
      this.childNavLinks.forEach((a) => {
        a.blur();
        a.classList.remove(classes.isActive);
      });

      var el = this.childNavLinks[index];
      el.classList.add(classes.isActive);

      if (!this.args.childNavScroller) {
        return;
      }

      if (this.args.childVertical) {
        var elTop = el.offsetTop;
        this.args.childNavScroller.scrollTop = elTop - 100;
      } else {
        var elLeft = el.offsetLeft;
        this.args.childNavScroller.scrollLeft = elLeft - 100;
      }
    },

    arrowClick: function (evt) {
      if (
        evt.currentTarget.classList.contains("product__thumb-arrow--prev")
      ) {
        this.slideshow.previous();
      } else {
        this.slideshow.next();
      }
    },
  });

  return slideshow;
})();

/*============================================================================
  VariantAvailability
  - Cross out sold out or unavailable variants
  - To disable, set dynamicVariantsEnable to false in theme.liquid
  - Required markup:
    - class=variant-input-wrap to wrap select or button group
    - class=variant-input to wrap button/label
==============================================================================*/

theme.SlideshowSection = (function () {
  var selectors = {
    parallaxContainer: ".parallax-container",
  };

  function SlideshowSection(container) {
    this.container = container;
    var sectionId = container.getAttribute("data-section-id");
    this.slideshow = container.querySelector("#Slideshow-" + sectionId);
    this.namespace = "." + sectionId;

    this.initialIndex = 0;

    if (!this.slideshow) {
      return;
    }

    // Get shopify-created div that section markup lives in,
    // then get index of it inside its parent
    var sectionEl = container.parentElement;
    var sectionIndex = [].indexOf.call(
      sectionEl.parentElement.children,
      sectionEl,
    );

    if (sectionIndex === 0) {
      this.init();
    } else {
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
      });
    }
  }

  SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
    init: function () {
      var slides = this.slideshow.querySelectorAll(".slideshow__slide");

      if (this.container.hasAttribute("data-immediate-load")) {
        this.slideshow.classList.remove("loading", "loading--delayed");
        this.slideshow.classList.add("loaded");
      } else {
        // Wait for image to load before marking as done
        theme.loadImageSection(this.slideshow);
      }

      if (slides.length > 1) {
        var sliderArgs = {
          prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
          pageDots: this.slideshow.hasAttribute("data-dots"),
          fade: true,
          setGallerySize: false,
          initialIndex: this.initialIndex,
          autoPlay:
            this.slideshow.dataset.autoplay === "true"
              ? parseInt(this.slideshow.dataset.speed)
              : false,
        };

        this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
      } else {
        // Add loaded class to first slide
        slides[0].classList.add("is-selected");
      }

      if (this.container.hasAttribute("data-parallax")) {
        // Create new parallax for each slideshow image
        this.container.querySelectorAll(selectors.parallaxContainer).forEach(
          function (el, i) {
            new theme.Parallax(el, {
              namespace: this.namespace + "-parallax-" + i,
            });
          }.bind(this),
        );
      }
    },

    forceReload: function () {
      this.onUnload();
      this.init();
    },

    onUnload: function () {
      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }
    },

    onDeselect: function () {
      if (this.flickity && typeof this.flickity.play === "function") {
        this.flickity.play();
      }
    },

    onBlockSelect: function (evt) {
      var slide = this.slideshow.querySelector(
        ".slideshow__slide--" + evt.detail.blockId,
      );
      var index = parseInt(slide.dataset.index);

      if (this.flickity && typeof this.flickity.pause === "function") {
        this.flickity.goToSlide(index);
        this.flickity.pause();
      } else {
        // If section reloads, slideshow might not have been setup yet, wait a second and try again
        this.initialIndex = index;
        setTimeout(
          function () {
            if (this.flickity && typeof this.flickity.pause === "function") {
              this.flickity.pause();
            }
          }.bind(this),
          1000,
        );
      }
    },

    onBlockDeselect: function () {
      if (this.flickity && typeof this.flickity.play === "function") {
        if (this.flickity.args.autoPlay) {
          this.flickity.play();
        }
      }
    },
  });

  return SlideshowSection;
})();

